import { createAction } from '@reduxjs/toolkit';

export const UPDATE_QUEUE_ENTRY_ACTION_TYPE = 'saga/updateQueueEntry';
export const updateQueueEntryAction = createAction(UPDATE_QUEUE_ENTRY_ACTION_TYPE);
